import { motion, AnimatePresence } from "framer-motion";
import { WhatsAppIcon } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";
import { waLink } from "../data/site";

export default function FloatingWhatsApp({ introDone }) {
  const { T } = useLang();
  return (
    <AnimatePresence>
      {introDone && (
        <motion.div
          className="group fixed bottom-5 right-5 z-[80] md:bottom-7 md:right-7"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6 }}
          transition={{ delay: 0.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="pointer-events-none absolute right-full top-1/2 mr-3 -translate-y-1/2 whitespace-nowrap rounded-full bg-federasol-cocoa px-4 py-2 text-xs font-medium text-federasol-cream opacity-0 shadow-lg transition-all duration-300 ease-soft group-hover:opacity-100 md:block hidden">
            {T.floating.tooltip}
          </span>
          <span className="absolute inset-0 animate-ping rounded-full bg-[#1FAF54]/35" />
          <a
            href={waLink(T.wa.default)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label={T.floating.aria}
            className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#1FAF54] text-white shadow-[0_14px_36px_-8px_rgba(31,175,84,0.65)] transition-transform duration-300 ease-soft hover:scale-105"
          >
            <WhatsAppIcon className="h-7 w-7" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
